exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".css-form input.ng-invalid.ng-touched{box-shadow:0 0 0 .1rem #d41e1e}.css-form input.ng-valid.ng-touched{box-shadow:0 0 0 .1rem #4caf50}", "", {"version":3,"sources":["/./src/app/components/documentRequestModalComponent/src/app/components/documentRequestModalComponent/documentrequestmodalcomponent.scss"],"names":[],"mappings":"AAAA,sCACE,8BAAyC,CAC1C,AAED,oCACE,8BAAyC,CAC1C","file":"documentrequestmodalcomponent.scss","sourcesContent":[".css-form input.ng-invalid.ng-touched {\n  box-shadow: 0 0 0 0.1rem rgb(212, 30, 30);\n}\n\n.css-form input.ng-valid.ng-touched {\n  box-shadow: 0 0 0 0.1rem rgb(76, 175, 80);\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?root=/opt/buildhome/repo/src&sourceMap!./node_modules/postcss-loader!./node_modules/sass-loader?outputStyle=expanded&sourceMap=true&sourceMapContents=true!./src/app/components/documentRequestModalComponent/documentrequestmodalcomponent.scss
// module id = 906
// module chunks = 0